import {useSelector} from "react-redux";
import {State} from "@App/state";

export const useCalculation = () => {

    const organization = useSelector((state: State) => state.orders.organization)
    const service = useSelector((state: State) => state.orders.service)
    const garage = useSelector((state: State) => state.orders.garage)

    const filterBrand = useSelector((state: State) => state.filters.brand)
    const brand = useSelector((state: State) => state.orders.brand)
    const generation = useSelector((state: State) => state.orders.generation)
    const motorization = useSelector((state: State) => state.orders.motorization)
    const body = useSelector((state: State) => state.orders.body)
    const gearbox = useSelector((state: State) => state.orders.gearbox)
    const mileage = useSelector((state: State) => state.orders.mileage)
    const initialRegistrationDate = useSelector((state: State) => state.orders.initialRegistrationDate)
    const subRepairs = useSelector((state: State) => state.orders.subRepairs)
    const equipments = useSelector((state: State) => state.orders.equipments)
    const premiumServices = useSelector((state: State) => state.orders.premiumServices)

    return {
        organization,
        service,
        garage,
        filterBrand,
        brand,
        generation,
        motorization,
        body,
        gearbox,
        mileage,
        initialRegistrationDate,
        subRepairs,
        equipments,
        premiumServices
    }
}


